// /application/services-ui/notifyService.js

import Notify from 'simple-notify';
import { alertMessages } from './alertMessages'

export const useNotify = () => {
    const showAlert = (alertKey) => {
      const alert = alertMessages[alertKey]
  
      if (alert) {
        new Notify(alert)
      } else {
        console.warn(`No alert message found for key: ${alertKey}`)
      }
    }
  
    return { showAlert }
  }